import React, {forwardRef} from 'react';
import logo from '../../assets/imagenes/logo.png';
import firebase from '../../utils/firebase';
import { useSelector } from 'react-redux'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import { useState } from 'react';
import Snackbar from '@mui/material/Snackbar'; //actualizacion nodejs
import MuiAlert from '@mui/material/Alert'; //actualizacion nodejs
import types from '../../actions/types'

const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function Login() {
  const [formData, setFormData] = useState(defaultValue());
  const [mensaje, setMensaje] = useState('');
  const [respuesta, setRespuesta] = useState(false);
  const [iniciando, setIniciando] = useState(false);
  const {syncs} =  useSelector((state)=>{ return state });
  const [vendedor, setVendedor] = useState(syncs.vendedor);
  var user =  firebase.auth().currentUser;

  const handleLogin  = () =>{
    setIniciando(true);
    let errors = {};
    if ((!formData.password || !formData.passwordC )) {
      if (!formData.password) errors.password = true;
      if (!formData.passwordC) errors.passwordC = true;
    } else if ( formData.password !== formData.passwordC ) {
      errors.password = true;
      errors.passwordC = true;
      setMensaje(types.PASSWORD_DIF);
      setRespuesta(true);
    }else{
      user.updatePassword(formData.passwordC).then(() => {
        setMensaje(types.PASSWORD_NEW);
        setFormData(defaultValue());

      }).catch((error) => { 
        setMensaje(types.PASSWORD_FAIL);
      });
      setIniciando(false);
      setRespuesta(true)
    }
    setIniciando(false);
  };


  const onChange = (e, type) => {
    setFormData({...formData, [type]: e.target.value});
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setRespuesta(false);
  };

  return ( 
    < div style={{justifyContent: "center", alignItems: "center", display: "block"}}>
      <div>
      <div>
        <img className="App-logo" src={logo} alt="logo" height="120" />
      </div>
      <div>
        <span style={{fontSize: 18}}>{`${vendedor && vendedor.vendedor_nombre ?"Hola, "+vendedor.vendedor_nombre: ""}`}</span>
      </div>
      <div>
        <span style={{fontSize: 15}}>{`${vendedor && vendedor.numero_vendedor? "Clave: " + vendedor.numero_vendedor: ""}`}</span>
      </div>
      <div>
        <Form onSubmit={e => e.preventDefault() && false}>
          <Form.Group controlId="formBasicnewContra">
            <Form.Control 
            type="password" 
            placeholder="Nueva contraseña"
            style={styles.input}  
            required
            autoComplete="new-password" 
            minLength="6"
            onChange={(e) => onChange(e, 'password')}/>
          </Form.Group>
          <Form.Group controlId="formBasicPassword">
            <Form.Control 
            type="password" 
            placeholder="Confirmar nueva contraseña"
            style={styles.input} 
            required
            autoComplete="new-password" 
            minLength="6"
            onChange={(e) => onChange(e, 'passwordC')}/>
          </Form.Group>
          <Button variant="primary" type="submit"  disabled={iniciando} style={styles.botones} onClick={handleLogin}> MODIFICAR </Button>
        </Form>
      </div>
      <br/>
      </div>
      <Snackbar open={respuesta} autoHideDuration={6000} onClose={handleClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
            <Alert onClose={handleClose} severity={types.PASSWORD_NEW === mensaje? "success": "error"}>
              {mensaje}
            </Alert>
          </Snackbar>
    </div>
  );
}

function defaultValue() {
  return {
    email: '',
    passwordC: '',
  };
}

const styles = {
  input: {
    height: 60,
    color: '#fff',
    width: '100%',
    backgroundColor: '#3f51b5',
    paddingHorizontal: 20,
    borderRadius: 50,
    fontSize: 18,
    borderWidth: 1,
    borderColor: '#3f51b5',
    marginTop: 25,
    alignSelf: "center"
  },
  btnText: {
    color: '#fff',
    fontSize: 18,
  },
  register: {
    flex: 1,
    justifyContent: 'flex-end',
    marginBottom: 10,
  },
  error: {
    borderColor: '#940c0c',
  },
  botones:{
    marginTop:'20px', 
    marginBottom:'10px',
    alignItems:"center", 
    width:"100%", 
    alignSelf:"center", 
    elevation:.5, 
    alignContent:"center",
    backgroundColor: '#3f51b5',

  },
  container: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    alignSelf: "center",
    width: "100%",
    height: "100%"
  },
};
export default Login;
